"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AvatarIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Image = _interopRequireDefault(require("../Image"));
var AvatarIcon = exports.AvatarIcon = function AvatarIcon(_ref) {
  var avatarUrlWebp = _ref.avatarUrlWebp,
    avatarUrl = _ref.avatarUrl,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    size = _ref.size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react["default"].createElement(StyledImageComponent, {
    src: avatarUrlWebp !== null && avatarUrlWebp !== void 0 ? avatarUrlWebp : avatarUrl,
    alt: name,
    fallback: avatarUrl,
    $size: size,
    className: className
  });
};
var StyledImageComponent = (0, _styledComponents["default"])(_Image["default"]).withConfig({
  displayName: "AvatarIcon__StyledImageComponent",
  componentId: "sc-11dt88j-0"
})(["height:", "px;width:", "px;border-radius:", "px;object-fit:cover;"], function (_ref2) {
  var $size = _ref2.$size;
  return $size;
}, function (_ref3) {
  var $size = _ref3.$size;
  return $size;
}, function (_ref4) {
  var $size = _ref4.$size;
  return $size;
});
var _default = exports["default"] = AvatarIcon;